import { Component, OnInit } from '@angular/core';
export class MainToolbarRightMenuComponent implements OnInit {
constructor() { }
/**
 * @return {?}
 */
ngOnInit() {
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-main-toolbar-right-menu',
  template: `
    <div class="right-menu-wrapper">
        <ul class="right-menu-list">
            <ng-content></ng-content>
        </ul>
    </div>
  `,
  styles: [`
    :host {
      display: table;
      table-layout: fixed;
      width: auto;
      height: 100%;
      float: right;
      padding: 0px; }

    .right-menu-wrapper {
      display: table-cell;
      vertical-align: top;
      height: 100%;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      -webkit-font-smoothing: antialiased;
      line-height: 1.5;
      color: #212529;
      background-color: #fff; }

    .right-menu-list {
      margin: 0 20px 0 30px;
      display: inline-block;
      height: 100%;
      width: auto;
      padding: 0;
      list-style: none;
      font-size: 14px;
      font-weight: 300;
      font-family: "Poppins";
      line-height: 1.5;
      color: #212529; }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MainToolbarRightMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarRightMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarRightMenuComponent.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
